<template>
  <div class="ErrorList">
    <!-- 选择地址 -->
    <el-dialog :visible.sync="maskShow" center :show-close="false" class="addrescancel">
      <subAddress ref="subAddress" :key="Math.random()" @onCancel="handleAddressCancel" @update:show="handleAddressCancel" @onChange="handleAddressChange" />
    </el-dialog>
    <!-- 进口商地址 -->
    <el-dialog :visible.sync="importerShow" center :show-close="false" class="addrescancel">
      <importerAddress ref="importerAddress" :key="Math.random()" @onCancel="importerOnCancel" @update:show="importerOnCancel" @onChange="handleImporterAddressChange" />
    </el-dialog>
    <el-dialog
        :title="$t('cart.applyMessage29' || '选择进口商信息')"
        :visible="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
        width="820px"
        center
    >
      <div>
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="auto"
            label-suffix=":"
            class="demo-ruleForm"
        >
          <el-form-item :label="$t('cart.applyMessage32' || '收货地址')" prop="receiver">
            <div style="display: flex; align-items: center;">
              <el-input v-model="ruleForm.receiver" :placeholder="$t('cart.applyMessage26')" :readonly="true"> </el-input>
              <el-button type="primary" @click="handleOnChange()" style="padding: 8px 20px">{{ $t("cart.applyMessage25" || '选择') }}</el-button>
            </div>
          </el-form-item>
           <el-form-item :label="$t('fba.sendAddress' || '进口商地址')" prop="senderConfigAddressInfoName">
            <div style="display: flex; align-items: center;">
              <el-input v-model="ruleForm.senderConfigAddressInfoName" :placeholder="$t('common.pleaseSelect')" :readonly="true"> </el-input>
              <el-button type="primary" @click="importerOnChange()" style="padding: 8px 20px">{{ $t("cart.applyMessage25" || '选择') }}</el-button>
            </div>
            <!-- <el-select v-model="ruleForm.senderConfigAddressInfoName" :placeholder="$t('common.pleaseSelect')" size="small" clearable>
              <el-option
                v-for="item in sendReceivingAddress"
                :key="item.id"
                :label="item.detailedAddresserInfo"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item :label="$t('fba.line' || '线路')" prop="route">
            <el-select
              v-model="ruleForm.route"
              :placeholder="$t('common.pleaseSelect')"
              size="small"
              clearable
              @change='lineChenge'
            >
              <el-option
                v-for="item in routeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('fba.logisticsCompany' || '物流公司')" prop="logisticeCompany">
            <el-select
              v-model="ruleForm.logisticeCompany"
              :placeholder="$t('common.pleaseSelect')"
              size="small"
              clearable
              @change="logisticeChenge"
            >
              <el-option
                v-for="item in dropDownListEdit"
                :key="item.id"
                :label="item.companyName"
                :value="item.companyName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('createOrder.createOrder117' || '上传附件')">
            <my-upload
              size="mini"
              v-model="attachmentList"
              :limit="5"
              mode="array"
              :keyObject="{url:'url',name:'name'}"
              multiple
              listType="text"
              class="upload-style-custom">
              <el-button class="search-btn btn-blue">{{ $t('createOrder.createOrder117') }}</el-button>
            </my-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="" style="display: flex;justify-content: flex-end;">
        <el-button class="form-btn btn-blue" @click="submitForm('ruleForm')">{{ $t('cart.applyMessage34' || '确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import subAddress from "../../../components/sub/subAddress.vue";
import importerAddress from "../../../components/sub/importerAddress.vue";
export default {
  name: "apply-goods",
  components: {
    subAddress,
    importerAddress,
  },
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      ruleForm: {
        senderConfigAddressInfoName: '',
        senderConfigAddressInfoId: '',
        route: '',
        logisticeCompany: '',
        logisticsCompanyId: '',
        receiver: '',
        receiverConfigAddressInfoId: '',
      },
      maskShow: false,
      importerShow: false,
      attachmentList: [],
      rules: {
        senderConfigAddressInfoName: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder3'), trigger: 'blur' },
        ],
        route: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder5'), trigger: 'blur' },
        ],
        logisticeCompany: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder6'), trigger: 'blur' },
        ],
        receiver: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder4'), trigger: 'blur' },
        ],
      },
      sendReceivingAddress: [],
      routeList: [
        {
          value: '1',
          label: this.$t('FBAContainerOrder.FBAContainerOrder1')
        },
        {
          value: '2',
          label: this.$t('FBAContainerOrder.FBAContainerOrder2')
        }
      ],
      dropDownListEdit: []
    }
  },
  mounted() {
    console.log('row====',this.row)
    // 用于回显
    this.$nextTick(async() => {
      if(
          this.row.route 
          && this.row.logisticsCompanyId 
          && this.row.receiverConfigAddressInfoId
      ){
        await this.getList()
        await this.lineChenge(this.row.route)
        this.ruleForm.route = this.row.route
        this.ruleForm.logisticsCompanyId = this.row.logisticsCompanyId
        this.ruleForm.receiverConfigAddressInfoId = this.row.receiverConfigAddressInfoId
        this.ruleForm.senderConfigAddressInfoId = this.row.senderConfigAddressInfoId
        this.attachmentList = JSON.parse(this.row.attachment)
        this.ruleForm.logisticeCompany = this.dropDownListEdit.find(item => item.id == this.row.logisticsCompanyId).companyName
      }
    })
    this.getSendAddress()
  },
  methods: {
    async getList() {
      let data1 = {
        type: 0,
        id:this.row.receiverConfigAddressInfoId
      };
      let url = "cms/configAddressInfo/list";
      const { data: res1 } = await this.$http.get(url, { params: data1 });
      this.ruleForm.receiver = res1.data.list[0].receiverName
      let data2 = {
        type: 1,
        id:this.row.senderConfigAddressInfoId
      };
      const { data: res2 } = await this.$http.get(url, { params: data2 });
      this.ruleForm.senderConfigAddressInfoName = res2.data.list[0].receiverName
    },
    handleAddressChange(addressData) {
      console.log("选中的地址数据:", addressData);
      
      // 更新表单中的收货人信息
      this.ruleForm.receiver = `${addressData.receiverName || ''}`.trim();
      this.ruleForm.receiverConfigAddressInfoId = `${addressData.id || ''}`;
      // 关闭地址选择对话框
      this.maskShow = false;
    },
    handleImporterAddressChange(addressData) {
    console.log("选中的进口商地址数据:", addressData);
    
    // 更新表单中的进口商地址信息
    this.ruleForm.senderConfigAddressInfoId = `${addressData.id || ''}`;
    this.ruleForm.senderConfigAddressInfoName = `${addressData.receiverName || ''}`;
    // 关闭进口商地址选择对话框
    this.importerShow = false;
  },
    // 选择收货地址弹窗
    handleOnChange() {
      this.maskShow = true;
    },
    handleAddressCancel() {
      this.maskShow = false;
    },
    // 选择进口商地址
    importerOnChange() {
      this.importerShow = true;
    },
    importerOnCancel() {
      this.importerShow = false;
    },
    //从后台获取收货地址
    async getSendAddress () {
      const { data: res } = await this.$http.post(
          "container/sendReceivingAddress"
      )
      this.sendReceivingAddress = res.data
    },
    // 选择线路
    async lineChenge (e) {
      await this.getDropDownForLineList(e)
      this.ruleForm.logisticeCompany = ''
      this.ruleForm.logisticsCompanyId = ''
    },
    async getDropDownForLineList (line) {
      if (line) {
        const { data: res } = await this.$http.get("cms/logisticsCompany/getDropDownForLineList/" + line + "?username="+window.sessionStorage.getItem('username'))
        this.dropDownListEdit = res.data
      } else {
        this.dropDownListEdit = []
      }
    },
    // 选择物流公司
    logisticeChenge (value) {
      this.ruleForm.logisticsCompanyId = this.dropDownListEdit.find(item => item.companyName === value).id
    },
    submitForm(formName) {
      console.log(this.ruleForm)
      console.log(this.attachmentList)
      this.$refs[formName].validate((valid) => {
        if (valid) {
              // 父组件更新使用
              this.$options.confirm({
                ...this.ruleForm,
                attachment: JSON.stringify(this.attachmentList)
              })
        } else {
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.ErrorList{
  :deep(.el-dialog__body){
    padding: 0 20px;
  }
  :deep(.el-dialog__footer){
    padding: 0 20px 20px;
  }
}
.upload-style-custom{
  ::v-deep .el-upload{
    text-align: left;
  }
}
::v-deep .el-input__inner{
  height: 32px;
}
.addrescancel{
  ::v-deep .el-dialog__header{
    padding: 0;
  }
}
</style>
